import { useContext } from 'react';
import { ResponsiveContext } from '../../utils/responsive.es.js';

var useOS = function useOS() {
  var context = useContext(ResponsiveContext);
  return context.os;
};

export { useOS };